export default __webpack_public_path__ + "static/media/logo_transparent_background.264f7191.png";